export default __webpack_public_path__ + "static/media/logoCropped.b875828b.png";